import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserAuthService } from 'src/app/auth/user-auth.service'; 

@Component({
  selector: 'app-idle-logout',
  templateUrl: './idle-logout.component.html',
  styleUrls: ['./idle-logout.component.scss']
})
export class IdleLogoutComponent implements OnInit, OnDestroy {
  vc_timeLeft: number = 120;
  vc_interval: any;

  constructor(public oc_dialogRef: MatDialogRef<IdleLogoutComponent>,
    private oc_userAuthService: UserAuthService, private oc_router: Router,
    @Inject(MAT_DIALOG_DATA) public oc_data: any) { }

  ngOnDestroy(): void {
    this.vc_timeLeft = 120;
    this.vc_interval = null;
  }

  ngOnInit(): void {
    this.fn_startTimer();
  }

  fn_logout(): void {
    this.oc_dialogRef.close({
      logout: true,
    });
    this.oc_userAuthService.clear(); 
  }

  fn_cancel() {
    this.oc_dialogRef.close({
      logout: false,
    }); 
  }

  fn_startTimer() {
    this.vc_interval = setInterval(() => {
      if(this.vc_timeLeft > 0) {
        this.vc_timeLeft--;
      } else {
        this.fn_logout();
      }
    },1000)
  }

}
